import React, { useEffect, useState, useRef, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { glClassificationApi } from '../../../resources/hooks/api/glClassificationApi';
import { useSettingsApi } from '../../../resources/hooks/api/useSettingsApiHook';
import { MONTHS, URLS } from '../../../resources/constants'
import { getBranch } from '../../../store/user/selectors'
import { getFirstLoginStatus } from '../../../store/settings/selectors'
import '../GlClassification.css'

interface Props {

}

const SalesGlClassificationStatus: React.FC<Props> = () => {
    const { t } = useTranslation('scenes.glclassification.sales');
    const { classificationListStatus, completeStep } = glClassificationApi();
    const { fetchAccountSettingsData: userStepStatusFn } = useSettingsApi();
    const navigate = useNavigate();

    const branchData = useSelector(getBranch)
    const userStepStatus = useSelector(getFirstLoginStatus);

    const [records, setRecords] = useState<any | null>(null);
    const [posType, setPosType] = useState<string>("");
    const [months, setMonths] = useState<any | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [userStepCompleted, setUserStepCompleted] = useState<number>(userStepStatus);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0);

    useEffect(() => {
        const months = MONTHS.reduce((a: any, c: any) => {
            a = {
                ...a,
                [+c['value']]: c['label']
            }
            return a;
        }, {})
        setMonths(months);

        fetchList();
        fetchUserSteps();
    }, [])
    useEffect(() => {
        setUserStepCompleted(userStepStatus)
    }, [userStepStatus]);

    useEffect(() => {
        if (userStepCompleted && userStepCompleted == 3) {
            userCompleteStep(4);
            navigate('/')
        }
    }, [userStepCompleted]);

    const fetchUserSteps = () => {
        setIsLoading(true);
        userStepStatusFn({ branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
        }, (message: string, resp: any) => {
            setIsLoading(false);

        })
    }

    const fetchList = () => {
        setIsLoading(true);
        classificationListStatus({ account_type: 2, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            setPosType(resp.data.data.pos_type);
            setRecords(resp.data.data.transactions);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const userCompleteStep = (step: number) => {
        setIsLoading(true);
        completeStep({ branch_id: +branchData['id'], type: 2, step }, (message: string, resp: any) => {
            setIsLoading(false);
            navigate(URLS.DASHBOARD)
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }


    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-6 page-title align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t('status.title')}</h1>
                        </div>
                        {/* <div className="col-sm-6 justify-content-end align-items-center d-flex">
                            <Link to={URLS.DASHBOARD} className="btn btn-link">{t('button.back_dashboard')}</Link>
                        </div> */}
                    </div>
                </div>

                {
                    userStepCompleted < 3 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            {
                                posType == 'sales_with_channel' ? (
                                    <>{t('alert.populate_sales')} <br />
                                        {t('alert.populate_sales_step1')} <br />
                                        {t('alert.populate_sales_step2')}</>
                                ) : (
                                    // <>In order to populate Sales Classification Data complete Revenue GL Classification</>
                                    <>{t('alert.close_month')}</>
                                )
                            }
                        </Alert>
                    ) : userStepCompleted >= 3 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            {t('alert.nothing_to_classify')}
                        </Alert>
                    ) : <></>
                }

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                            <div className="loader"></div>
                        </div>
                        <div className="table-responsive list-table table-scroll">
                            <table className="table table-default">
                                <thead>
                                    <tr className="align-middle">
                                        <th className="text-center">{t('table.month')}</th>
                                        <th className="text-center">{t('table.year')}</th>
                                        <th className="text-center">{t('table.status')}</th>
                                        <th className="text-center">{t('table.action')}</th>
                                        <th className="text-center">{t('table.ai_status')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        records && records.map((data: any, index: number) => (
                                            <tr className="align-middle h-60" key={index}>
                                                <td className="text-center">
                                                    {months[data['item']['month']]}
                                                </td>
                                                <td className="text-center">
                                                    {data['item']['year']}
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data['status'] == 'posted' ? <Badge bg="success">{t('status.completed')}</Badge> : data['status'] == 'partial_posted' ? <Badge bg="warning">{t('status.pending')}</Badge> : <Badge bg="warning">{t('status.pending')}</Badge>}
                                                    </h6>
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        data['status'] != 'posted' ? 
                                                            <Link to={`/revenue-gl-classification/${data['item']['month']}/${data['item']['year']}`}>{t('button.classify')}</Link> : 
                                                            <span>{t('status.na')}</span>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data?.['ai_classification_status'] == 2 ? 
                                                            <Badge bg="danger">{t('status.ai.failed')}</Badge> : 
                                                            data?.['ai_classification_status'] == 1 ? 
                                                                <Badge bg="success">{t('status.ai.completed')}</Badge> : 
                                                                <Badge bg="warning">{t('status.ai.pending')}</Badge>
                                                        }
                                                    </h6>
                                                </td>
                                            </tr>))
                                    }
                                    {
                                        records && records.length == 0 && (
                                            <tr>
                                                <td colSpan={5} className='text-center'>
                                                    <p>{t('alert.no_records')}</p>
                                                    {
                                                        userStepCompleted < 3 && (
                                                            <button className='btn btn-cancel' onClick={() => userCompleteStep(3)}>{t('button.skip_step')}</button>
                                                        ) || <></>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        {/* <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} recordPerPage={recordPerPage} lastIndex={lastIndex} firstIndex={firstIndex} npage={npage} /> */}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SalesGlClassificationStatus;